module.exports = __webpack_public_path__ + "img/loginlogo.e66073e9.png";